module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard-font"
  }, [_c('div', [_c('label', [_vm._v(_vm._s(_vm.$parent.locale["heading"]) + ":")]), _vm._v(" "), _vm._l((6), function(h) {
    return _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setHeading(h + 1)
        }
      }
    }, [_vm._v("H" + _vm._s(h + 1))])
  })], 2), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n            " + _vm._s(_vm.$parent.locale["font name"]) + ":\n        ")]), _vm._v(" "), _vm._l((_vm.nameList), function(name) {
    return _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setFontName(name)
        }
      }
    }, [_vm._v(_vm._s(name))])
  })], 2), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n            " + _vm._s(_vm.$parent.locale["font size"]) + ":\n        ")]), _vm._v(" "), _vm._l((7), function(size) {
    return _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setFontSize(size + 1)
        }
      }
    }, [_vm._v(_vm._s(size + 1))])
  })], 2), _vm._v(" "), _c('div', [_c('label', [_vm._v("\n            " + _vm._s(_vm.$parent.locale["line height"]) + ":\n        ")]), _vm._v(" "), _vm._l((_vm.lineHeightList), function(lh) {
    return _c('button', {
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.setLineHeight(lh)
        }
      }
    }, [_vm._v("\n            " + _vm._s(lh) + "\n        ")])
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-0230f4c8!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/src/modules/font/dashboard.vue
// module id = 602
// module chunks = 0